require('./RAImageButton.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { RadioButton } = require('commonsComponents/radioButton');

class RAImageButton extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange() {
        this.props.onChange(this.props);
    }

    buildLabelContent() {
        const { label, size, isSelected } = this.props;
        const labelClassName = classnames(
            'ra-image-button__label',
            `ra-image-button__label--${size}`,
        );
        return (
            <RadioButton
                label={label}
                value={label}
                className={labelClassName}
                isChecked={isSelected}
            />
        );
    }

    render() {
        const {
            extraClass,
            extraClassForGoalWrapper,
            extraContent,
            iconType,
            id,
            isSelected,
            label,
            size,
        } = this.props;

        const goalClassName = classnames(
            'ra-image-button',
            extraClass,
            `ra-image-button--${size}`,
            {
                [`ra-image-button-${iconType}`]: !!iconType,
            },
        );
        const labelContent = !!label ? this.buildLabelContent() : null;
        const goalWrapperClassName = classnames(extraClassForGoalWrapper, {
            'ra-image-button__selected': isSelected && !!iconType,
            [`ra-image-button-goalcontent--${size}`]: !!iconType,
        });

        return (
            <div onClick={this.handleChange}>
                <div className={goalWrapperClassName}>
                    <div className={goalClassName} id={id}>
                        {extraContent}
                    </div>
                </div>
                {labelContent}
            </div>
        );
    }
}

RAImageButton.propTypes = {
    extraClass: PropTypes.string,
    extraContent: PropTypes.object,
    iconType: PropTypes.string.isRequired,
    id: PropTypes.string,
    isSelected: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func,
    size: PropTypes.string,
    extraClassForGoalWrapper: PropTypes.string,
};

RAImageButton.defaultProps = {
    isSelected: false,
    size: 'medium',
    label: null,
};

module.exports = RAImageButton;
